module.exports = __webpack_public_path__ + "img/minus.391d6163.svg";